import { memo, useEffect, useState, useRef, useMemo } from "react"

import ProductService from "@/services/product"
import { Stack, Text, Image, AspectRatio, Center, Button, Container, Box, Table, IconButton, Flex, VStack, Separator, Drawer, Portal, CloseButton, Input } from "@chakra-ui/react"
import { useCart } from "contexts/cart"
import { formatCurrency } from "@/utilities/number"
import { LuPencil } from "react-icons/lu"

import { StepperInput } from "@/components/ui/stepper-input"
import { useApp } from "contexts/app"
import { useNavigate } from "react-router"
import PointService from "@/services/point"
import _ from "lodash"
const service = new PointService();

const VoucherInput = () => {
    const [open, setOpen] = useState(false)
    const ref = useRef(null);
    const cart = useCart();

    const [canApply, setCanApply] = useState(false);
    const [error, setError] = useState();
    const [warning, setWarning] = useState();
    const [point, setPoint] = useState(0);
    const [maxPerOrder, setMaxPerOrder] = useState(0);
    const [inputPoint, setinputPoint] = useState(0);
    useEffect(()=>{
        if (inputPoint > point) {
            setError("Bạn không đủ xu");
            setWarning(null);
            setCanApply(false);
            return;
        }
        setError(null);
        if (maxPerOrder > 0 && inputPoint > maxPerOrder) {
            setWarning(`Mỗi đơn hàng chỉ được dùng tối đa ${formatCurrency(maxPerOrder)} xu.`);
            setCanApply(false);
            return;
        }
        setWarning(null);
        setCanApply(true);

    },[point, inputPoint, maxPerOrder])
    const onVoucherChange = (e) => {

        var num = parseInt(e.target.value);
        if (isNaN(num)) {
            setinputPoint(0);
            return;
        }
        setinputPoint(num);
      
    }
    useEffect(() => {

        setError(null);
        loadPoint();
        setCanApply(false);
    }, [open])


    const loadPoint = async () => {
        var a = await service.get();
        setPoint(a.point)
        setMaxPerOrder(Math.max(0, Number(a.max_per_order) || 0));
    }


    const applyPoint = async () => {
        try {
            await cart.setPoint(inputPoint)
            setOpen(false);
        } catch (err) {
            const msg = err?.message || "Không thể áp dụng xu";
            setError(msg);
            setCanApply(false);
        }
    }





    return (
        <>
            <Button variant={"ghost"} onClick={e => setOpen(true)} style={{ padding: 0, minWidth: 10 }}>
                Xu
            </Button>

            <Portal>


                <Drawer.Root open={open} onOpenChange={(e) => setOpen(e.open)} placement={"bottom"} initialFocusEl={() => ref.current} closeOnInteractOutside={false}>
                    <Drawer.Backdrop />
                    <Drawer.Positioner>
                        <Container maxWidth={"lg"} style={{ padding: 0 }}>
                            <Drawer.Content>


                                <Drawer.Header>
                                    <Drawer.Title>Xu</Drawer.Title>
                                </Drawer.Header>
                                <Drawer.Body>
                                    <Stack >

                                        <Input type="number" ref={ref} value={inputPoint==0?"":inputPoint} placeholder="Xu" onChange={onVoucherChange} />
                                        <Center fontSize="sm">Xu hiện tại: <Button variant={"ghost"} onClick={e=>setinputPoint(point)}> {formatCurrency(point)} </Button> </Center>
                                        <div>
                                            {error &&
                                                <Text color={"red.500"}>{error}</Text>
                                            }
                                            {!error && warning &&
                                                <Text color={"orange.500"}>
                                                    {warning}{" "}
                                                    <Text as="span" color={"orange.600"} textDecoration="underline" cursor="pointer" onClick={() => setinputPoint(maxPerOrder)}>
                                                        Dùng {formatCurrency(maxPerOrder)} xu
                                                    </Text>
                                                </Text>
                                            }

                                        </div>
                                    </Stack>



                                </Drawer.Body>
                                <Drawer.Footer>
                                    <Button variant="outline" onClick={e => { setOpen(false) }}>Cancel</Button>
                                    <Button disabled={!canApply} onClick={applyPoint}>Áp dụng</Button>
                                </Drawer.Footer>
                                <Drawer.CloseTrigger asChild>
                                    <CloseButton size="sm" />
                                </Drawer.CloseTrigger>

                            </Drawer.Content>
                        </Container>
                    </Drawer.Positioner>
                </Drawer.Root>

            </Portal>
        </>
    )
}

export default memo(VoucherInput)